/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useReducer, useState } from "react";
import { GetStarted } from "../components/getting_started/getStarted";
import {
  SignIn,
  ForgotPassword,
  ForgotPasswordLinkSent,
} from "../components/getting_started/signin";
import {
  SignupFirstStep,
  SignupLastStep,
  SignupVerified,
  SignupVerify,
} from "../components/getting_started/signup";
import Record from "../components/record_qcast/record";
import { Qcasts, Search } from "../components/view_qcast/qcast";
import Play from "../components/view_qcast/play";
import Respond from "../components/respond_qcast/respond";
import Review from "../components/record_qcast/review";
import {
  Trim,
  Thumbnail,
  Edit,
  Transcript,
  IntroOrOutro,
} from "../components/record_qcast/edit";
import ReviewResponse from "../components/respond_qcast/review-response";
import {
  EditResponse,
  ResponseScript,
  ResponseThumbnail,
} from "../components/respond_qcast/edit-response";
import PlayResponse from "../components/view_qcast/play-response";

const initial = {
  getStarted: true,
  signin: false,
  reset: false,
  resetlink: false,
  signup: false,
  lastStep: false,
  verify: false,
  verified: false,
  record: false,
  review: false,
  edit: false,
  transcript: false,
  thumbnail: false,
  view: false,
  play: false,
  playresponse: false,
  respond: false,
  reviewresponse: false,
  editresponse: false,
  responsescript: false,
  search: false,
  //
  intro: false,
  outro: false,
};

const reducer = (state, action) => {
  switch (action) {
    case "getStarted":
      return { ...initial, signin: false, signup: false, getStarted: true };
    case "signin":
      return {
        ...initial,
        getStarted: false,
        signin: true,
        reset: false,
        resetlink: false,
      };
    case "reset":
      return {
        ...initial,
        signin: false,
        reset: true,
        resetlink: false,
        getStarted: false,
      };
    case "resetlink":
      return { ...initial, reset: false, resetlink: true, getStarted: false };
    case "signup":
      return { ...initial, getStarted: false, signup: true, lastStep: false };
    case "search":
      return {
        ...initial,
        signup: false,
        signin: false,
        search: true,
        view: false,
        record: false,
        verified: false,
        lastStep: false,
        getStarted: false,
      };
    case "record":
      return {
        ...initial,
        search: false,
        record: true,
        review: false,
        getStarted: false,
      };
    case "review":
      return {
        ...initial,
        record: false,
        review: true,
        edit: false,
        transcript: false,
        thumbnail: false,
        //
        intro: false,
        outro: false,
        getStarted: false,
      };
    case "edit":
      return {
        ...initial,
        review: false,
        edit: true,
        trim: false,
        getStarted: false,
      };
    case "trim":
      return { ...initial, edit: false, trim: true, getStarted: false };
    case "transcript":
      return { ...initial, review: false, transcript: true, getStarted: false };
    case "thumbnail":
      return { ...initial, review: false, thumbnail: true, getStarted: false };
    case "lastStep":
      return {
        ...initial,
        signup: false,
        lastStep: true,
        verify: false,
        reviewresponse: false,
        review: false,
        verified: false,
        search: false,
        getStarted: false,
      };
    case "verify":
      return {
        ...initial,
        signup: false,
        lastStep: false,
        verify: true,
        verified: false,
        getStarted: false,
      };
    case "verified":
      return {
        ...initial,
        verify: false,
        verified: true,
        lastStep: false,
        getStarted: false,
      };
    case "view":
      return {
        ...initial,
        welcome: false,
        view: true,
        play: false,
        playresponse: false,
        search: false,
        getStarted: false,
      };
    case "play":
      return {
        ...initial,
        view: false,
        play: true,
        respond: false,
        getStarted: false,
      };
    case "playresponse":
      return { ...initial, view: false, playresponse: true, getStarted: false };
    case "respond":
      return {
        ...initial,
        play: false,
        respond: true,
        reviewresponse: false,
        getStarted: false,
      };
    case "reviewresponse":
      return {
        ...initial,
        respond: false,
        reviewresponse: true,
        lastStep: false,
        editresponse: false,
        responsescript: false,
        responsethumbnail: false,
        getStarted: false,
      };
    case "editresponse":
      return {
        ...initial,
        reviewresponse: false,
        editresponse: true,
        getStarted: false,
      };
    case "responsescript":
      return {
        ...initial,
        reviewresponse: false,
        responsescript: true,
        getStarted: false,
      };
    case "responsethumbnail":
      return {
        ...initial,
        reviewresponse: false,
        responsethumbnail: true,
        getStarted: false,
      };
    //
    case "addIntro":
      return { ...initial, review: false, intro: true, getStarted: false };
    case "addOutro":
      return { ...initial, review: false, outro: true, getStarted: false };
    default:
      return state;
  }
};

const useCurrentState = () => {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState();
  const [current, dispatch] = useReducer(reducer, initial);
  const [isTrimming, setIsTrimming] = useState(false);

  useEffect(() => {
    if (current.getStarted)
      setState(
        <GetStarted
          signin={() => dispatch("signin")}
          signup={() => dispatch("signup")}
        />
      );
    else if (current.signin)
      setState(
        <SignIn
          back={() => dispatch("getStarted")}
          reset={() => dispatch("reset")}
          proceed={() => dispatch("search")}
        />
      );
    else if (current.reset)
      setState(
        <ForgotPassword
          back={() => dispatch("signin")}
          resetlink={() => dispatch("resetlink")}
        />
      );
    else if (current.resetlink)
      setState(
        <ForgotPasswordLinkSent
          back={() => dispatch("reset")}
          signin={() => dispatch("signin")}
        />
      );
    else if (current.signup)
      setState(
        <SignupFirstStep
          back={() => dispatch("getStarted")}
          view={() => dispatch("search")}
          verify={() => dispatch("verify")}
        />
      );
    else if (current.search)
      setState(
        <Search
          viewsearch={() => dispatch("view")}
          record={() => dispatch("record")}
          getStarted={() => dispatch("getStarted")}
        />
      );
    else if (current.view)
      setState(
        <Qcasts
          back={() => dispatch("search")}
          play={() => dispatch("play")}
          respond={() => dispatch("respond")}
          playresponse={() => dispatch("playresponse")}
        />
      );
    else if (current.record)
      setState(
        <Record
          back={() => dispatch("search")}
          review={() => dispatch("review")}
        />
      );
    else if (current.lastStep)
      setState(
        <SignupLastStep
          back={() => dispatch("signup")}
          view={() => dispatch("search")}
          getStarted={() => dispatch("getStarted")}
        />
      );
    else if (current.verify)
      setState(
        <SignupVerify
          back={() => dispatch("signup")}
          verified={() => dispatch("verified")}
        />
      );
    else if (current.verified)
      setState(
        <SignupVerified
          back={() => dispatch("verify")}
          lastStep={() => dispatch("lastStep")}
        />
      );
    else if (current.review)
      setState(
        <Review
          back={() => dispatch("record")}
          transcript={() => dispatch("transcript")}
          edit={() => dispatch("edit")}
          thumbnail={() => dispatch("thumbnail")}
          laststep={() => dispatch("lastStep")}
          //
          addIntro={() => dispatch("addIntro")}
          addOutro={() => dispatch("addOutro")}
          proceed={() => dispatch("search")}
        />
      );
    else if (current.edit)
      setState(
        <Edit
          back={() => dispatch("review")}
          save={() => dispatch("review")}
          trim={() => dispatch("trim")}
        />
      );
    else if (current.trim)
      setState(
        <Trim
          back={() => dispatch("edit")}
          save={() => dispatch("edit")}
          setIsTrimming={setIsTrimming}
        />
      );
    else if (current.transcript)
      setState(<Transcript back={() => dispatch("review")} />);
    else if (current.thumbnail)
      setState(<Thumbnail back={() => dispatch("review")} />);
    else if (current.play)
      setState(
        <Play
          back={() => dispatch("view")}
          respond={() => dispatch("respond")}
        />
      );
    else if (current.playresponse)
      setState(<PlayResponse back={() => dispatch("view")} />);
    else if (current.respond)
      setState(
        <Respond
          back={() => dispatch("view")}
          reviewresponse={() => dispatch("reviewresponse")}
        />
      );
    else if (current.reviewresponse)
      setState(
        <ReviewResponse
          back={() => dispatch("respond")}
          editresponse={() => dispatch("editresponse")}
          responsescript={() => dispatch("responsescript")}
          responsethumbnail={() => dispatch("responsethumbnail")}
          proceed={() => dispatch("view")}
        />
      );
    else if (current.editresponse)
      setState(
        <EditResponse
          back={() => dispatch("reviewresponse")}
          setIsTrimming={setIsTrimming}
        />
      );
    else if (current.responsescript)
      setState(<ResponseScript back={() => dispatch("reviewresponse")} />);
    else if (current.responsethumbnail)
      setState(<ResponseThumbnail back={() => dispatch("reviewresponse")} />);
    else if (current.intro) {
      setState(
        <IntroOrOutro
          back={() => dispatch("review")}
          review={() => dispatch("review")}
          type="intro"
        />
      );
    } else if (current.outro) {
      setState(
        <IntroOrOutro
          back={() => dispatch("review")}
          review={() => dispatch("review")}
          type="outro"
        />
      );
    }
  }, [current]);

  return { open, state, setOpen, isTrimming };
};

export default useCurrentState;
